import { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../app/rootReducer";
import { getGroupInstitutions } from "../../slices/codeBookSlice";

export const useGetGroupInstitutions = (
  pedagogicalYearInstitutionId: number
) => {
  const groupInstitutions = useSelector(
    (state: RootState) => state.codeBook.groupInstitutions
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getGroupInstitutions(pedagogicalYearInstitutionId));
  }, [pedagogicalYearInstitutionId, dispatch]);

  return groupInstitutions;
};
